import { render, staticRenderFns } from "./BrainViz2.vue?vue&type=template&id=14ae6076&scoped=true"
import script from "./BrainViz2.vue?vue&type=script&lang=js"
export * from "./BrainViz2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ae6076",
  null
  
)

export default component.exports